import { useEffect, useState } from "react";
import { publicRequest } from "../requestMethods";
import { IPOH_INDOOR_SALESMAN_ID } from "../utils/ipohAccount";

export default function useIndoorSalesmanOptions(enabled) {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (!enabled) return undefined;
        let cancelled = false;
        publicRequest
            .get(`/users/find/${IPOH_INDOOR_SALESMAN_ID}`)
            .then((res) => {
                if (cancelled || !res.data?._id) return;
                setOptions([
                    {
                        label: `${res.data.phoneNumber} - ${res.data.name}`,
                        value: res.data._id,
                    },
                ]);
            })
            .catch((err) => console.error("Error fetching indoor salesman:", err));
        return () => {
            cancelled = true;
        };
    }, [enabled]);

    return options;
}
